import { EMessageType } from '@cian/chats-api';
import { ILogger } from '@cian/logger';

import { objIsOffer, objIsOfferV2 } from './presenter';
import { ChatMessageValidationError, ChatOfferValidationError, ChatUsersValidationError } from '../errors';
import { TChatDataInListSchema } from '../types/chatList';

interface IValidateChatItemParameters {
  chat?: TChatDataInListSchema;
  isV2Version?: boolean;
  logger?: ILogger;
}

export function validateChatItem({ chat, logger, isV2Version }: IValidateChatItemParameters): boolean {
  // Временная функция, пока нет возможности сделать logger обязательным
  const logError = (error: Error) => {
    if (logger) {
      logger.error(error);
    } else {
      console.error(error);
    }
  };

  try {
    if (!chat) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствуют корректные данные (chat is undefined)`,
          domain: 'utils.validate.validateChatItem',
        }),
      );

      return false;
    }
    if (
      !chat.withModerator &&
      !isV2Version &&
      (!chat.data || (chat.type === 'offer' && (!chat.data.offer || !objIsOffer(chat.data.offer))))
    ) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствует корректный data.offer, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }
    if (
      !chat.withModerator &&
      isV2Version &&
      (!chat.data || (chat.type === 'offer' && (!chat.data.offer || !objIsOfferV2(chat.data.offer))))
    ) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствует корректный data.offer, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }
    if (
      chat.withModerator &&
      isV2Version &&
      (!chat.data || (chat.type === 'offer' && !!chat.data.offer && !objIsOfferV2(chat.data.offer)))
    ) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствует корректный data.offer, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }
    if (
      chat.withModerator &&
      !isV2Version &&
      (!chat.data || (chat.type === 'offer' && !!chat.data.offer && !objIsOffer(chat.data.offer)))
    ) {
      logError(
        new ChatOfferValidationError({
          message: `В чате отсутствует корректный data.offer, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    if (!chat.lastMessage) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле lastMessage, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    if (!('userId' in chat.lastMessage)) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле lastMessage.userId, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            messageId: chat.lastMessage['messageId'],
          },
        }),
      );

      return false;
    }

    // поле теxt может быть необязательным, если это сообщение с вложением
    if (
      !('text' in chat.lastMessage) &&
      ![EMessageType.Offer, EMessageType.TextAndFiles].includes(chat.lastMessage['type'])
    ) {
      logError(
        new ChatMessageValidationError({
          message: `В чате отсутствует поле lastMessage.text, chatId: ${chat.chatId}, message.type: ${chat.lastMessage['type']}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            messageId: chat.lastMessage['messageId'],
          },
        }),
      );

      return false;
    }

    if (!chat.users) {
      logError(
        new ChatUsersValidationError({
          message: `В чате отсутствует поле users, chatId: ${chat.chatId}`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
          },
        }),
      );

      return false;
    }

    // TODO Это условие ломает много сценарие, но непонятно что дает. Нужно помониторить ошибки, если будут.
    // if (chat.users.length < 2) {
    //   logError(
    //     new ChatUsersValidationError({
    //       message: `В чате chatId: ${chat.chatId} в поле users менее двух собеседников`,
    //       domain: 'utils.validate.validateChatItem',
    //       details: {
    //         chatId: chat.chatId,
    //       },
    //     }),
    //   );

    //   return false;
    // }

    if (chat.users.length === 2 && chat.users[0].userId === chat.users[1].userId) {
      logError(
        new ChatUsersValidationError({
          message: `В чате chatId: ${chat.chatId} в поле users совпадают userId собеседников`,
          domain: 'utils.validate.validateChatItem',
          details: {
            chatId: chat.chatId,
            chatUsers: chat.users.map(user => user.userId),
          },
        }),
      );

      return false;
    }

    return true;
  } catch (error) {
    logError(error);

    return false;
  }
}
